import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from '@shared/services/loading.service';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ButtonModule],
  templateUrl: './app.html',
  styleUrls:[]
})
export class App {
  protected readonly title = signal('fe-website');
  private readonly translate = inject(TranslateService);
  private readonly loadingService = inject(LoadingService);
  readonly loading = this.loadingService.loading;
  

  constructor() {
    this.translate.addLangs(['it', 'en']);
    this.translate.setFallbackLang('it');
    this.translate.use('it');
  }

  switchLang(lang: string) {
    this.translate.use(lang);
  }

  onSubmit(): void {
  }
}